import styled from "@emotion/styled";
import { translatePlural } from "@kaltura/mediaspace-shared-utils";

const StyledResultsCount = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
    fontSize: theme.typography.fontSize,
}));

/**
 * Global search results count
 */
export function ResultsCount(props: { totalCount: number; searchInLabel?: string }) {
    const { totalCount, searchInLabel } = props;

    return (
        <StyledResultsCount className="kms-ds-global-search-results-count">
            {!searchInLabel && translatePlural("%1 Result found", "%1 Results found", [totalCount])}
            {searchInLabel
                && translatePlural("%1 Result found in %2", "%1 Results found in %2", [totalCount, searchInLabel])}
        </StyledResultsCount>
    );
}
export default ResultsCount;
